export const AR = {
    translations: {
        notifications: 'إشعارات',
        markAllAsRead: 'اشر عليها بانها قرات',
        poweredBy: 'مشغل بواسطة',
        settings: 'الإعدادات',
        noNewNotification: 'لا يوجد شيء جديد تراه هنا حتى الآن',
    },
    lang: 'ar',
};
//# sourceMappingURL=ar.js.map